import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import * as ScrollMagic from 'scrollmagic';

import './one.scss';

import GsapContainer from '../../components/gsapContainer';
import TimelineHorizontally from '../../components/timelineHorizontally/timelineHorizontally';

function One(props) {
  const {setSection, status, setCurrentDate, anchor } = props;

  useEffect(() => {
    
    window.scrollTo({
      top: 0
    })
    
  }, [])

  return (
    <>
      <GsapContainer
      // controller={controller}
      // duration={1000}
      // trigger=".first-screen"
      // pin=".first-screen__slider"
      // animate={animate}
      setSection={setSection}
      status={status}
      setCurrentDate={setCurrentDate} anchor={anchor}
      >
        {({ progress, setEndOne, show }) => (
            <TimelineHorizontally progress={progress} setEndOne={setEndOne} show={show}  setCurrentDate={setCurrentDate} anchor={anchor}/>
        )}
      </GsapContainer>
    </>
  );
}

export default One;
